"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var optional_1 = __importDefault(require("../optional"));
__export(require("./arrayUtils"));
__export(require("./keyUtils"));
__export(require("./stringUtils"));
function delay(timeout) {
    return new Promise(function (resolve) { return setTimeout(resolve, timeout); });
}
exports.delay = delay;
function once(fn) {
    var p = fn;
    return function () {
        var result = p && p.apply(this, arguments);
        p = undefined;
        return result;
    };
}
exports.once = once;
function getValueOrOptional(cached) {
    if (cached.isScan) {
        return cached.value;
    }
    return cached.state === "missing" ? optional_1.default.none() : optional_1.default.some(cached.value);
}
exports.getValueOrOptional = getValueOrOptional;
function deprecated(newMethod) {
    var notified = false;
    return function (target, propertyKey, descriptor) {
        var originalValue = descriptor.value;
        descriptor.value = function () {
            if (!notified) {
                if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
                    var name_1 = target.constructor.name;
                    console.warn("the " + name_1 + "." + propertyKey + " method is deprecated, please use " + name_1 + "." + newMethod + " instead");
                }
                notified = true;
            }
            return originalValue.apply(this, arguments);
        };
    };
}
exports.deprecated = deprecated;
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ../../src/utils/index.ts